"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinleyAiPromptResponseTerminalStatuses = exports.FinleyAiTextractSupportedFileExtensionIterable = exports.FinleyAiExtractValuesPageNumberSupportedFileExt = exports.FinleyAiExtractValuesFileExtToEngineSupport = exports.FinleyAiExtractValuesEngineFileExtSupport = exports.FinleyAiExtractValuesDefaultEngine = exports.FinleyAiVirtualSheetSupportedFileExtensionIterable = exports.FinleyAiExtractValuesEngineSchema = exports.finleyAiVirtualSheetFormulaQuestionsSchema = exports.finleyAiVirtualSheetFormulaQuestionSchema = void 0;
const v4_1 = require("zod/v4");
exports.finleyAiVirtualSheetFormulaQuestionSchema = v4_1.z.object({
    fieldName: v4_1.z.string(), // name of the field to extract
    fieldPrompt: v4_1.z.string(), // question to ask the LLM for the field.
});
exports.finleyAiVirtualSheetFormulaQuestionsSchema = v4_1.z
    .array(exports.finleyAiVirtualSheetFormulaQuestionSchema)
    .min(1);
exports.FinleyAiExtractValuesEngineSchema = v4_1.z.enum([
    'pdfMiner',
    'textract',
    'beautifulSoup',
    'rawText',
]);
exports.FinleyAiVirtualSheetSupportedFileExtensionIterable = Object.freeze(['xlsx', 'xlsb', 'xlsm']);
exports.FinleyAiExtractValuesDefaultEngine = {
    html: 'beautifulSoup',
    pdf: 'pdfMiner',
    jpeg: 'textract',
    jpg: 'textract',
    json: 'rawText',
    png: 'textract',
    tif: 'textract',
    tiff: 'textract',
    txt: 'rawText',
};
exports.FinleyAiExtractValuesEngineFileExtSupport = {
    beautifulSoup: ['html'],
    textract: ['pdf', 'png', 'jpeg', 'jpg', 'tif', 'tiff'],
    pdfMiner: ['pdf'],
    rawText: ['txt', 'json'],
};
// reverse map of FinleyAiExtractValuesEngineFileExtSupport
exports.FinleyAiExtractValuesFileExtToEngineSupport = Object.entries(exports.FinleyAiExtractValuesEngineFileExtSupport).reduce((acc, [eng, exts]) => {
    exts.forEach((ext) => {
        acc[ext].push(eng); // guaranteed by type system, Object.entries loses typing
    });
    return acc;
}, {
    html: [],
    pdf: [],
    png: [],
    jpeg: [],
    jpg: [],
    json: [],
    tiff: [],
    tif: [],
    txt: [],
});
exports.FinleyAiExtractValuesPageNumberSupportedFileExt = [
    'pdf',
    'png',
    'jpeg',
    'jpg',
    'tiff',
    'tif',
];
exports.FinleyAiTextractSupportedFileExtensionIterable = exports.FinleyAiExtractValuesEngineFileExtSupport.textract;
exports.FinleyAiPromptResponseTerminalStatuses = [
    'failure',
    'success',
];
//# sourceMappingURL=FinleyAi.js.map